module.exports = __webpack_public_path__ + "static/media/17359231_10154599607273990_8778746484665412956_o.9dc787f3.jpg";